import { useCreateTeams } from './hooks/useCreateTeams';

export const CreateTeams = () => {
	const { getComponent } = useCreateTeams();

	return getComponent();
};
